var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeDarkIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#83301b;}.cls-3{fill:#cc3c27;}.cls-4{fill:#331b14;}.cls-5{fill:#281410;}.cls-6{fill:#682d16;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.51C517.13,227.16,318.89,21.06,311,12.73c-8.55-9-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.09-14.29-.8-14.29-.8s-4-5.23-17.63-1.28C233.58,13.11,7.86,70.47,7.86,70.47S.77,72.29.69,79.56,0,124.31,0,124.31,195.25,375.69,202.91,385.65c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,231.62,519.39,229.51Zm-95-57.25L240.4,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L426.2,165C428.84,167.78,428,171.06,424.36,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.7,185.58C483.81,183.62,318.61,11.86,312,4.93c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C247.52,5.24,59.42,53,59.42,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S215.58,307.39,222,315.69c5.23,6.83,18.36,2.08,18.36,2.08S477.05,232,482.57,229.92c4.84-2.07,4.49-6.38,4.49-6.38l.11-31.59S487.34,187.34,485.7,185.58Zm-61.34-13.32L240.4,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L426.2,165C428.84,167.78,428,171.06,424.36,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M483.08,182.73S318.61,11.75,312,4.81c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S272.11-2,260.71,1.31C247.52,5.12,59.42,52.93,59.42,52.93s-8.71,3-3.6,9.42c5.37,7.05,48.6,63.65,48.6,63.65S211.92,261.24,220,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S483.08,182.73,483.08,182.73Zm-58.72-10.47L240.4,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L426.2,165C428.84,167.78,428,171.06,424.36,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "244.78 281.15 244.78 308.67 477.59 224.48 477.59 201.17 244.78 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "477.59 201.17 461.25 206.84 477.59 224.48 477.59 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.11,128.13l-7.75,1.57C124.63,151.42,212.71,262.23,220,271.29A15.6,15.6,0,0,0,231.72,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M483.08,182.73S412.55,109.41,362,56.84l-4.08,1.74L485.34,191.4C488.37,187.58,483.08,182.73,483.08,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.66,58.53C111.18,60.72,92.94,67.2,103,80.09S128,93.35,145.44,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.42-8.71-44.77-4.92S128.14,56.33,119.66,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.07,13.22l-2-2L293,17.92a30.56,30.56,0,0,1,3.68,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.45,70.72,67.76,78.07l1.92,2.51,25.79-6.91A9.14,9.14,0,0,1,95.45,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.28,17.6l-1.95-2-22.27,6a28.92,28.92,0,0,1,2.44,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.27,82.62l1.92,2.5,24.24-6.47A16.56,16.56,0,0,1,96.14,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.61,27.77l21.75-5.92-1.94-2-21.6,5.86c.31.33.63.67.94,1S306.34,27.42,306.61,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.24,81.29,75.18,87.8l1.94,2.49,24.14-6.59c-.48-.53-1-1.08-1.42-1.65C99.62,81.79,99.44,81.54,99.24,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.9,92.56l1.94,2.49L106,88.16c-.87-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.45,26.1l-1.94-2-22.24,6.05a17,17,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.1,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.25,37.37l26.16-7.16-1.93-2-24.32,6.61A8.49,8.49,0,0,1,310.25,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M432.3,165.28,332.7,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.18,4.17L430,174.66C434.64,173.1,435.7,168.87,432.3,165.28Zm-7.94,7L240.4,233a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L426.2,165C428.84,167.78,428,171.06,424.36,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.13,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.31-7.3c3.14-1,5.28.8,4.75,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDarkIsometric);
export default __webpack_public_path__ + "static/media/orange-dark-isometric.7b9a976e681c41af5222e97b7834fb66.svg";
export { ForwardRef as ReactComponent };